<template>
  <div class="query-page">
    <div class="container">
      <div class="left-panel">
        <h2>全日制<span class="highlight">自考</span></h2>
        <p>官方录取信息查询</p>
        <img style="height: 20px; margin-bottom: 57px; margin-top: 17px"
          src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x44.png" alt="education book" />
        <div class="image-box">
          <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x43.png" alt="education book" />
        </div>
      </div>
      <div class="right-panel">
        <div class="student-info">
          <h3>学生报名录取信息</h3>
          <div class="form-container">
            <div class="row">
              <div class="label ">姓&nbsp;&nbsp;&nbsp;&nbsp;名</div>
              <div class="value elp">{{ studentInfo.fullName }}</div>
              <div class="label">身份证号</div>
              <div style="width: 170px;flex-shrink: 0;" class="value">{{ studentInfo.idNumber }}</div>
            </div>
            <div class="row">
              <div class="label">性&nbsp;&nbsp;&nbsp;&nbsp;别</div>
              <div class="value elp">{{ studentInfo.sex == '1' ? '男' : '女' }}</div>
              <div class="label">报名时间</div>
              <div  style="width: 170px;flex-shrink: 0;" class="value elp">{{ studentInfo.createTime }}</div>
            </div>
            <div style="border-bottom: 0;" class="row address-row">
              <div class="label">家庭地址</div>
              <div class="value elp address-value">{{ studentInfo.homeAddress }}</div>
            </div>

            <div class="stamp">
              <img v-if="studentInfo.status == 1" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x48.png"
                alt="">
              <img v-if="studentInfo.status == 2" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x49.png"
                alt="">
            </div>
          </div>

          <div class="change-major">
            <p class="title">调换报名录取专业</p>
            <p class="titles">请在以下表选择您要调换的专业</p>
            <el-form :model="majorForm" label-width="100px">
              <el-form-item label="原专业一">
                {{ studentInfo.firstChoiceName }}
              </el-form-item>
              <el-form-item label="换专业一">
                <el-select filterable v-model="majorForm.changeMajor1" placeholder="请选择专业">
                  <el-option v-for="item in majorOptions" :key="item.zId" :label="item.zName" :value="item.zId" />
                </el-select>
              </el-form-item>

              <el-form-item label="原专业二">
                {{ studentInfo.secondChoiceName }}

              </el-form-item>
              <el-form-item label="换专业二">
                <el-select filterable v-model="majorForm.changeMajor2" placeholder="请选择专业">
                  <el-option v-for="item in majorOptions" :key="item.zId" :label="item.zName" :value="item.zId" />
                </el-select>
              </el-form-item>


            </el-form>
          </div>
          <el-button type="primary" @click="submitMajorChange" class="submit-btn">立即提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { codeObj } from "@/api/register";
import { TeacherClient } from '@/api/teacherClient.js'
let teacherClient = new TeacherClient()

export default {
  data() {
    return {
      codeKey: "",
      codeImg: "",
      form: {
        name: "",
        idNumber: "",
        captcha: "",
      },
      showInfo: false,
      studentInfo: {},

      majorForm: {
        originalMajor1: "",
        changeMajor1: "",
        originalMajor2: "",
        changeMajor2: "",
      },

      majorOptions: [
      ],
    };
  },
  created() {
    this.studentInfo = JSON.parse(this.$route.query.signUpInfo)
   teacherClient.selectZhuanyeByKind({
        kindId: 1
      }).then((res) => {
        this.majorOptions = res.msg
      })
  },
  methods: {
    submitMajorChange() {
      if (!this.majorForm.changeMajor1 && !this.majorForm.changeMajor2) {
        this.$message.error("请选择调换专业");
        return;
      }
      teacherClient.editSignUpInfo({
        firstChoiceId: this.majorForm.changeMajor1,
        secondChoiceId: this.majorForm.changeMajor2,
        id: this.studentInfo.id
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("调换成功");
        } else {
          this.$message.error(res.msg);
        }
      })

    }
  },
};
</script>

<style lang="less" scoped>
.query-page {
  display: flex;
  justify-content: center;
  align-items: center;
  // min-height: 100vh;
  height: 800px;
  background: url("https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x42.png");
  background-size: 100% 100%;

  .container {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;

    .left-panel {
      font-family: Source Han Sans SC, Source Han Sans SC;
      font-weight: bold;
      font-size: 50px;
      line-height: 70px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #1e2224;

      h2 {
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: bold;
        font-size: 50px;
        color: #1e2224;

        line-height: 70px;

        .highlight {
          color: #3a83fc;
        }
      }

      p {
        margin: 5px 0;
      }

      .image-box {
        img {
          width: 528px;
          object-fit: contain;
        }
      }
    }

    .right-panel {
      width: 521px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 1px rgba(204, 204, 204, 0.34);
      border-radius: 24px;
      padding: 24px;


      h3 {
        font-family: Source Han Sans SC, Source Han Sans SC;
        font-weight: 500;
        font-size: 26px;
        color: #333333;
        line-height: 36px;
        text-align: center;
        margin-bottom: 50px;
      }

      /deep/ .el-input {
        width: 333px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 0;

      }

      /deep/ .el-input__inner {
        width: 333px;
        height: 44px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 0;
      }



      .submit-btn {
        width: 398px;
        height: 51px;
        background: linear-gradient(90deg, #509fff 0%, #086aeb 100%);
        box-shadow: 0px 3px 20px 1px rgba(69, 151, 252, 0.6);
        border-radius: 8px;
        margin: 0 auto;
        margin-top: 24px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        display: block;
      }

      .student-info {
        h3 {
          text-align: center;
          margin-bottom: 20px;
        }

        .change-major {
          width: 473px;
          height: 307px;
          background: #E1F6FF;
          border-radius: 12px 12px 12px 12px;
          margin-top: 12px;
          padding: 20px 0;

          .title {

            font-family: Source Han Sans SC, Source Han Sans SC;
            font-weight: 500;
            font-size: 20px;
            color: #0074EF;
            text-align: center;
          }

          .titles {

            font-family: Source Han Sans SC, Source Han Sans SC;
            font-weight: 400;
            font-size: 14px;
            color: #777777;
            text-align: center;
            margin-top: 8px;
            margin-bottom: 10px;

          }
        }
      }
    }
  }
}


.form-container {
  width: 473px;
  height: 169px;
  background: #F6FBFF;
  border-radius: 12px 12px 12px 12px;
  position: relative;
  padding: 0 24px; 
  padding-top: 6px;

  .row {
    display: flex;
    align-items: center;
    border-bottom: 1px dashed #eee;
    // padding: 8px 0;
    height: 53px;
    

    &:last-child {
      border-bottom: none;
    }

    .label {
      width: 70px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #627785;
      line-height: 21px;
      text-align: justify;
      text-align-last: justify;
      flex-shrink: 0;
    }

    .value {
 overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
      width: 120px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 16px;
      color: #333333;

      margin-left: 15px;
    }
  }

  .address-row {
    .label {
      width: 70px;
      // padding-right: 10px;
      vertical-align: top;
      line-height: 1.5;
    }

    .address-value {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .stamp {
    position: absolute;
    bottom: 15px;
    right: 15px;
    // width: 120px;
    // height: 120px;

    img {
      width: 106px;
    }
  }
}

/deep/ .el-form-item {
  margin-bottom: 10px;
}
/deep/ .el-select-dropdown__list {
  padding: 16px !important;
  padding-bottom: 0 !important;
}
.el-select-dropdown__item {
  height: 44px !important;
  line-height: 44px !important;
  background: #F5F9FC;
  border-radius: 8px 8px 8px 8px;
  text-align: center;
  margin-bottom: 5px;
}

.hover {
  height: 44px;
  background: linear-gradient( 90deg, #509FFF 0%, #086AEB 100%);
  border-radius: 8px 8px 8px 8px;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
}
::v-deep .el-form-item__label{
  color: #627785 !important;
}
::v-deep .el-select-dropdown__list {
  padding: 16px !important;
  padding-bottom: 0 !important;
}
.el-select-dropdown__list {
  padding: 16px !important;
  padding-bottom: 0 !important;
}
</style>
